<template>
  <section class="hero-clinic bg-cover" style="background:white;">
    <div class="clinic-hero-wrapper" style="padding-top:50px">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="clinic-hero-title text-center section-space--mb_40">
              <h1 class="heading mb-10" style="font-size:3.2rem">Sandrasoft</h1>
              <h1 class="sub-text" style="font-size: 2rem">
                Healthcare platform that connects people.
              </h1>
              <!-- <div class="sub-text" style="font-size: 2.5vh">
                Manage patient administration end-to-end with our novel <br />
                HIS solutions
              </div> -->
            </div>
            <div class="ht-contact-hero-box">
              <div class="ht-contact-hero-box--inner">
                <div
                  class="clinic-button"
                  style="text-align: center; padding-bottom: 2.5vh"
                >
                  <b-link
                    href="https://calendly.com/nichealpham/experiment1et"
                    class="ht-btn ht-btn-lg ht-btn--outline"
                    style="margin: 0 1rem 1rem"
                  >
                    Contact Us For A Demo
                  </b-link>
                  <button
                    @click="redirect('/blogs')"
                    type="submit"
                    class="ht-btn ht-btn-lg"
                    style="margin: 0 1rem"
                  >
                    Read Our Blogs & Articles
                  </button>
                </div>
              </div>
            </div>
            <iframe
              width="100%"
              height="720"
              src="https://pitch.com/public/046884ec-8ee8-4910-a8a6-8b14e86d838d"
              allowfullscreen
              class="fit_iframe mt-3"
            ></iframe>
          </div>
        </div>
      </div>
      <div
        class="clinic-hero-bottom section-space--pt_90"
        style="margin-top:-50px;"
      >
        <div class="vc_row-separator big_triangle_alt bottom">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            preserveAspectRatio="none"
            viewBox="0 0 100 100"
          >
            <polygon points="0,0 50,100 100,0 101,100 0 101"></polygon>
          </svg>
        </div>
        <div class="clinic-hero-image">
          <img
            src="../../assets/img/hero/clinic/aeroland-clinic-hero-image.png"
            class="img-fluid"
            alt="clinic hero thumbnail"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    bookMeeting() {
      window.open("https://calendly.com/nichealpham/experiment1et");
    },
  },
};
</script>

<style>
@media only screen and (max-width: 1324px) {
  .fit_iframe {
    width: 100% !important;
    height: 400px !important;
  }
}
@media only screen and (max-width: 600px) {
  .heading {
    font-size: 280% !important;
  }
  .sub-text {
    font-size: 180% !important;
  }
  .vc_row-separator.big_triangle_alt.bottom {
    display: none;
  }
  .fit_iframe {
    width: 100% !important;
    height: 300px !important;
  }
}
</style>
